var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09814 31.5C7.27314 31.5 6.56714 31.2065 5.98014 30.6195C5.39314 30.0325 5.09914 29.326 5.09814 28.5V7.5C5.09814 6.675 5.39214 5.969 5.98014 5.382C6.56814 4.795 7.27414 4.501 8.09814 4.5H29.0981C29.9231 4.5 30.6296 4.794 31.2176 5.382C31.8056 5.97 32.0991 6.676 32.0981 7.5V28.5C32.0981 29.325 31.8046 30.0315 31.2176 30.6195C30.6306 31.2075 29.9241 31.501 29.0981 31.5H8.09814ZM8.09814 28.5H29.0981V7.5H8.09814V28.5ZM9.59814 25.5H27.5981L21.9731 18L17.4731 24L14.0981 19.5L9.59814 25.5Z",
    fill: "#3969D5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.930820a2873f20cdddffa79aa2441c63.svg";
export { ForwardRef as ReactComponent };